import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {actions, Control, Errors, Form} from 'react-redux-form';
import {Button, Checkbox, Col, ControlLabel, FormControl, FormGroup, Radio, Row} from 'react-bootstrap';
import { get as _get } from 'lodash';
import {validators} from '../../../../utils/validators';
import {history} from '../../../../store';
import LayoutContainer from '../../../layout/layout-container/index';
import ErrorMessages from '../../login/error-messages';
import ConfirmPopup from '../../../common/confirm-popup';
import IgniteDataTable from '../../../common/datatable/index';
import UserTitleSelector from '../../../common/form/user/user-title-selector';
import UserFirstNameInput from '../../../common/form/user/user-first-name-input';
import UserLastNameInput from '../../../common/form/user/user-last-name-input';
import DateOfBirthSelector from '../../../common/form/user/date-of-birth-selector';
import ArrowButton from '../../../common/button-arrow';
import PendingOutletsTable from './pending-outlets-table';
import {checkPermission} from '../../../common/guards/can';
import {deleteUser, saveUser, updatePermissions, updateUser} from '../../../../actions/users';
import { tradeSiteEnabled } from '../../../../utils/toggles';

const outletColumns = [
  {
    prop: 'customer_number',
    title: 'Customer number',
    onClick: (cell, row) => {
      history.push(`/admin/outlets/${row.id}/view`);
    }
  }
];

if (tradeSiteEnabled()) {
  outletColumns.push({
    prop: 'full_address',
    title: 'Outlet address details',
    format: (address, { name }) => `${name}, ${address}`
  });
} else {
  outletColumns.push({ prop: 'name', title: 'Outlet name' });
}

class UserDetailsForm extends Component {
  state = {
    securityQuestion: ''
  };

  outletActions = [
    {
      label: 'DELINK FROM OWNER',
      permissions: {
        action: 'delink',
        subjectClass: 'Outlet'
      },
      callback: (row) => {
        history.push(`/admin/outlets/${row.id}/delink`);
      }
    }
  ];

  updateErrors = (field, value) => {
    this.setState({
      [field]: value
    });
  };

  toggleDeletePopup = () => {
    const {showDeletePopup} = this.state;
    this.setState({
      showDeletePopup: !showDeletePopup
    });
  };

  handleDeletePopup = (result) => {
    const {dispatch, user} = this.props;
    if (result) {
      dispatch(deleteUser(user.id))
        .then(history.push('/admin/users'));
    }

    this.toggleDeletePopup();
  };

  showSecurityAnswer = () => {
    const {user} = this.props;
    const {securityQuestion} = this.state;
    this.setState({
      securityAnswer: user.relationships['security-answers'].data
        .find(item => item.security_question_id === securityQuestion).answer
    });
  };

  onSubmitUser = (payLoad) => {
    const {dispatch, saveLink, user} = this.props;
    if (user.id) {
      dispatch(actions.submitFields('deep.admin_user.details', updateUser(saveLink, payLoad)))
        .then(() => {
          dispatch(actions.reset('deep.admin_user.details'));
          history.push('/admin/users');
        });
    } else {
      dispatch(actions.submitFields('deep.admin_user.details', saveUser(payLoad)))
        .then(() => {
          dispatch(actions.reset('deep.admin_user.details'));
          history.push('/admin/users');
        });
    }
  };

  onSubmitPermissions = (payLoad) => {
    const {dispatch, user} = this.props;
    dispatch(actions.submitFields('deep.admin_user.details.permission_ids', updatePermissions(user.id, payLoad)));
  };

  showLinkedOutlets() {
    const { user } = this.props;

    if (!user) return false;

    const { relationships } = user;
    const hasLinkedOutlets = relationships.outlets.data.length > 0;
    const hasPendingOutlets = _get(relationships, 'pending-outlets.data', []).length > 0;

    if (tradeSiteEnabled() && !hasLinkedOutlets && hasPendingOutlets) {
      return false;
    }

    return true;
  }

  render() {
    const {
      formValid, permissionFormValid, statuses, user
    } = this.props;
    const {
      securityAnswer, securityQuestion, showDeletePopup
    } = this.state;

    return (
      <LayoutContainer>
        <Form
          className="user-details-form"
          model="deep.admin_user.details"
          onSubmit={this.onSubmitUser}
          validateOn="submit"
          validators={{
            '': {
              account_locked: vals => vals.account_locked,
              thirty_day_exception: vals => vals.thirty_day_exception
            }
          }}
        >
          <Errors className="errors" component={ErrorMessages} model="deep.admin_user.details"/>
          <Row>
            <Col lg={6}>
              <UserTitleSelector model="deep.admin_user.details.title"/>

              <UserFirstNameInput/>

              <UserLastNameInput/>

              <DateOfBirthSelector/>
            </Col>

            <Col lg={6}>
              <ControlLabel>
                Communication preferences*
              </ControlLabel>
              <br/>
              <Col lg={3}>
                <FormGroup>
                  <Control.checkbox component={Checkbox} model=".comms_email" disabled>
                    email
                  </Control.checkbox>
                </FormGroup>
              </Col>
              <Col lg={9}>
                <FormGroup controlId="email" validationState={this.state.user_email}>
                  <Control.text
                    component={FormControl}
                    model=".email"
                    placeholder="Email"
                    type="email"
                  />

                  <Errors
                    className="errors"
                    model=".email"
                    show={{
                      touched: true,
                      focus: false
                    }}
                  />
                </FormGroup>
              </Col>
              <Col lg={3}>
                <FormGroup>
                  <Control.checkbox component={Checkbox} model=".comms_mobile" disabled>
                    mobile
                  </Control.checkbox>
                </FormGroup>
              </Col>
              <Col lg={9}>
                <FormGroup controlId="mobile" validationState={this.state.user_mobile}>
                  <Control.text
                    component={FormControl}
                    model=".mobile"
                    placeholder="Mobile"
                    type="tel"
                  />

                  <Errors
                    className="errors"
                    model=".mobile"
                    show={{
                      touched: true,
                      focus: false
                    }}
                  />
                </FormGroup>
              </Col>

              <FormGroup controlId="userStatus" validationState={this.state.user_status}>
                <ControlLabel>
                  Status*
                </ControlLabel>
                <Control.select
                  component={FormControl}
                  componentClass="select"
                  model=".status"
                  validators={{required: validators.required(this.updateErrors, 'user_status')}}
                >
                  <option value="">
                    Select status...
                  </option>
                  {
                    statuses &&
                    Object.keys(statuses)
                      .map(item => (
                        <option key={item} value={item}>
                          {statuses[item]}
                        </option>
                      ))
                  }
                </Control.select>

                <Errors
                  className="errors"
                  messages={{required: 'This field is required'}}
                  model=".status"
                  show={{
                    touched: true,
                    focus: false
                  }}
                />
              </FormGroup>

              <Row>
                <Col lg={6}>
                  <FormGroup controlId="userAccountLocked" validationState={this.state.account_locked}>
                    <div>
                      <ControlLabel>
                        Account locked*
                      </ControlLabel>
                    </div>
                    <Control.radio
                      component={Radio}
                      model=".account_locked"
                      validators={{required: validators.required(this.updateErrors, 'account_locked')}}
                      value="true"
                    >
                      Yes
                    </Control.radio>
                    <Control.radio
                      component={Radio}
                      model=".account_locked"
                      validators={{required: validators.required(this.updateErrors, 'account_locked')}}
                      value="false"
                    >
                      No
                    </Control.radio>

                    <Errors
                      className="errors"
                      messages={{required: 'You must set account lock state.'}}
                      model=".account_locked"
                      show={{touched: true}}
                    />
                  </FormGroup>
                </Col>
                <Col lg={6}>
                  <FormGroup controlId="userThirtyDayException" validationState={this.state.thirty_day_exception}>
                    <div>
                      <ControlLabel>
                        Exempt from 30 day closure*
                      </ControlLabel>
                    </div>
                    <Control.radio
                      component={Radio}
                      model=".thirty_day_exception"
                      validators={{required: validators.required(this.updateErrors, 'thirty_day_exception')}}
                      value="true"
                    >
                      Yes
                    </Control.radio>
                    <Control.radio
                      component={Radio}
                      model=".thirty_day_exception"
                      validators={{required: validators.required(this.updateErrors, 'thirty_day_exception')}}
                      value="false"
                    >
                      No
                    </Control.radio>

                    <Errors
                      className="errors"
                      messages={{required: 'You must set account lock state.'}}
                      model=".thirty_day_exception"
                      show={{touched: true}}
                    />
                  </FormGroup>
                </Col>
              </Row>
            </Col>

          </Row>
          <Row>
            <Col lg={6}>
              <FormGroup>
                <ControlLabel>
                  Security question
                </ControlLabel>
                <FormControl
                  componentClass="select"
                  onChange={e => this.setState({securityQuestion: +e.target.value})}
                  value={securityQuestion}
                >
                  <option value="" disabled>
                    Select a question...
                  </option>
                  {user.relationships && user.relationships['security-questions'].data.map(item => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </FormControl>
              </FormGroup>
              <Link to={`/admin/users/${user.id}/details/security-questions`}>
                <Button bsStyle="link" disabled={!checkPermission('update', 'SecurityQuestion')}>
                  Update security
                  questions
                </Button>
              </Link>
            </Col>
            <Col lg={6}>
              <Button
                className="red-ghost-btn view-answer"
                disabled={!securityQuestion}
                onClick={this.showSecurityAnswer}
              >
                View
              </Button>
              <span>
                {securityAnswer}
              </span>
            </Col>
            <ArrowButton
              className="pull-right"
              disabled={!formValid}
            >
              Save
            </ArrowButton>
            {
              user.relationships && user.relationships.outlets.data.length === 0 && (
                <ArrowButton
                  arrow={false}
                  className="pull-right"
                  color="grey"
                  onClick={this.toggleDeletePopup}
                  permissions={{
                    action: 'destroy',
                    subjectClass: 'User'
                  }}
                  submit={false}
                >
                  Delete user
                </ArrowButton>
              )}
            {
              showDeletePopup && (
                <ConfirmPopup
                  header="Delete user?"
                  onClose={this.handleDeletePopup}
                >
                  <p>
                    Do you really want to delete this user?
                    This operation will redact all personal information on the user record?
                  </p>
                </ConfirmPopup>
              )}
          </Row>
        </Form>
        <hr/>

        {
          user.relationships && user.relationships['staff-permissions'] && (
            <Form
              className="user-details-form"
              model="deep.admin_user.details.staff_permission_ids"
              onSubmit={this.onSubmitPermissions}
              validateOn="submit"
            >
              <Errors
                className="errors"
                component={ErrorMessages}
                model="deep.admin_user.details.staff_permission_ids"
              />
              <Row>
                <Col className="permissions-matrix" lg={12}>
                  <Row>
                    <Col className="permission-label" lg={8}>
                      <h5>
                        Permissions
                      </h5>
                    </Col>
                    <Col className="permission-label" lg={4}>
                      <Col lg={6}>
                        <h5>
                          Yes
                        </h5>
                      </Col>
                      <Col lg={6}>
                        <h5>
                          No
                        </h5>
                      </Col>
                    </Col>
                  </Row>
                  {
                    user.relationships['staff-permissions'].data.map(item => (
                      <Row key={item.id}>
                        <Col lg={8}>
                          <div>
                            {item.name}
                          </div>
                        </Col>
                        <Col lg={4}>
                          <Col lg={6}>
                            <Control.radio component={Radio} model={`.[${item.id}].checked`} value="true"/>
                          </Col>
                          <Col lg={6}>
                            <Control.radio component={Radio} model={`.[${item.id}].checked`} value="false"/>
                          </Col>
                        </Col>
                      </Row>
                    ))
                  }
                </Col>
              </Row>
              <Row>
                <ArrowButton
                  className="pull-right"
                  color="grey"
                  disabled={!permissionFormValid}
                >
                  Save
                </ArrowButton>
              </Row>
              <hr/>
            </Form>
          )}
        {
          this.showLinkedOutlets() && (
            <IgniteDataTable
              actions={this.outletActions}
              columns={outletColumns}
              data={user.relationships.outlets.data}
              hasAttributes={false}
            />
          )}
        {tradeSiteEnabled() && user && (<PendingOutletsTable/>)}
      </LayoutContainer>
    );
  }
}

const mapStateToProps = state => ({
  user: state.users.user,
  statuses: state.users.editorInput.statuses,
  userDetails: state.deep.admin_user.details,
  saveLink: state.users.saveLink,
  formValid: state.deep.forms.admin_user.details.$form.valid,
  permissionFormValid: state.deep.forms.admin_user.details.staff_permission_ids.$form.valid,
});

export default connect(mapStateToProps)(UserDetailsForm);



// WEBPACK FOOTER //
// ./src/components/admin/users/edit/user-details-form.jsx